import { Controller } from "@hotwired/stimulus"

// In-app inline confirmation: an action button reveals a confirm panel
// (with a real submit) instead of a native browser confirm() popup.
export default class extends Controller {
  static targets = ["trigger", "panel"]

  open() {
    if (this.hasTriggerTarget) this.triggerTarget.style.display = "none"
    if (this.hasPanelTarget) this.panelTarget.style.display = "block"
  }

  close() {
    if (this.hasPanelTarget) this.panelTarget.style.display = "none"
    if (this.hasTriggerTarget) this.triggerTarget.style.display = "inline-block"
  }
}
